/* ============================================================================
   AVISO DE FALLAS DE ESCRITURA

   Cierra el circuito: el registro publica, esto lo muestra.

   ══════════════════════════════════════════════════════════════════════════
   NO SE PUEDE CERRAR

   Un aviso con una «×» se cierra sin leer, por reflejo. Y este dice que algo
   que el piloto cree guardado **no está**: si se cierra, el dato se pierde
   igual y nadie se entera.

   Desaparece solo cuando la escritura vuelve a funcionar. Esa es la única
   forma legítima de que se vaya.
   ══════════════════════════════════════════════════════════════════════════
   ========================================================================== */

import React, { useEffect, useState } from "react";
import { escucharFallas, mensajeDeFallas } from "../../services/db/fallasEscritura.js";

export default function AvisoFallasEscritura() {
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => escucharFallas((lista) => setMensaje(mensajeDeFallas(lista))), []);

  if (!mensaje) return null;

  return (
    <div className="fallas-escritura" role="alert" aria-live="assertive">
      <strong className="fallas-escritura__titulo">{mensaje.titulo}</strong>
      <p className="fallas-escritura__detalle">{mensaje.detalle}</p>
      <p className="fallas-escritura__que-hacer">{mensaje.queHacer}</p>
      {mensaje.veces > 3 && (
        <p className="fallas-escritura__insistencia">
          Falló {mensaje.veces} veces: el almacenamiento no está funcionando.
          No sigas cargando datos hasta resolverlo.
        </p>
      )}
    </div>
  );
}
